const navToggle = document.querySelector(".nav-toggle");
const mobileNav = document.querySelector(".mobile-nav");

navToggle?.addEventListener("click", () => {
  const isOpen = mobileNav.classList.toggle("open");
  navToggle.setAttribute("aria-expanded", String(isOpen));
});

mobileNav?.addEventListener("click", (event) => {
  if (event.target instanceof HTMLAnchorElement) {
    mobileNav.classList.remove("open");
    navToggle?.setAttribute("aria-expanded", "false");
  }
});

document.querySelector(".signup-form")?.addEventListener("submit", (event) => {
  event.preventDefault();
});
